// extracted by mini-css-extract-plugin
module.exports = {"tab":"about-feature-tab_tab__0OK6e","icon":"about-feature-tab_icon__bPdmq","title":"about-feature-tab_title__memNf"};